module.exports = __webpack_public_path__ + "static/media/status-N.95b4ad1c.svg";